import { GenericFormItem } from 'skyone-lib/lib/GenericForm/interfaces';
import { fuseValue } from 'utils/fusoZones';

const fields: GenericFormItem[] = [
  {
    gridXs: 12,
    label: 'TIME_ZONE_KEY',
    stateKey: 'timezone',
    isSelect: true,
    options: fuseValue,
  },
];

export default fields;
